import { HTMLAttributes, memo } from 'react';
import styles from './FieldsRow.module.css';

export const FieldsRow =
  /**
   * FieldsRow component wraps its children inside a div styled with `fieldsRow` class.
   * Accepts all standard HTML div attributes and is memoized for performance.
   * @param props - Component props.
   * @param props.children - Elements to be rendered inside the row.
   * @returns Memoized row container component.
   */
  memo(
    ({ children, ...htmlAttributes }: HTMLAttributes<HTMLFieldSetElement>) => {
      return (
        <fieldset {...htmlAttributes} className={styles.fieldsRow}>
          {children}
        </fieldset>
      );
    },
  );

FieldsRow.displayName = 'FieldsRow';
